import EntityTypeEnum from 'common/enums/entityTypeEnum'
import CarouselInterface from 'common/types/entities/CarouselInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createCarousel(
  parentId: string,
  masterBlockId?: MasterBlockId,
): CarouselInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Carousel, parentId, masterBlockId),
    childIds: [],
    controlsColor: 'rgba(255, 255, 255, 1)',
    arrowsColor: 'rgba(255, 255, 255, 1)',
    padding: {
      paddingTop: 10,
      paddingRight: 10,
      paddingBottom: 10,
      paddingLeft: 10,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    showArrows: true,
  }
}
